export const MESSAGE_ERROR = 'Ocurrio un error, por favor contacte al administador.';